import { memo } from 'react';

import MinusIconSVG from '@/assets/minus-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IMinusIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={MinusIconSVG} {...props} />;

export const MinusIcon = memo(IMinusIcon) as typeof IMinusIcon;
